import CalloutHero from "./components/CalloutHero";
import CuratedCollections from "./components/CuratedCollections";
import CuratedPicks from "./components/CuratedPicks";
import { InstantSearchConfig, useConfig } from "../../config";
import { PromoBox } from "../../components/PromoBox/PromoBox";

export default function PromoPage() {
  const { promoPage } = useConfig() as InstantSearchConfig;


  return (
    <div className="tw-w-full tw-h-searchHeightShorter lg:tw-h-searchHeight tw-space-y-14 md:tw-pb-2 tw-pb-36 lg:tw-pr-2 tw-overflow-y-scroll">
      <div className="tw-opacity-0 tw-animate-fadeIn tw-delay-[300]">
        <PromoBox
          imgSrc={promoPage.promoBox.imgSrcMobile!}
          imgSrcMobile={promoPage.promoBox.imgSrcMobile}
          imgSrcTablet={promoPage.promoBox.imgSrcDesktop}
          imgSrcDesktop={promoPage.promoBox.imgSrcDesktop}
          heading={promoPage?.promoBox?.heading}
          paragraph={promoPage?.promoBox?.paragraph}
          linkHref={promoPage?.promoBox?.linkHref}
          linkText={promoPage?.promoBox?.linkText}
          disableGrid
          className="tw-min-h-[320px]"
          contentPosition={promoPage.promoBox.contentPosition}
        />
      </div>

      <div className="tw-opacity-0 tw-animate-fadeIn tw-delay-[600]">
        <CuratedCollections title={promoPage.curatedCollectionsTitle} collections={promoPage?.curatedCollections || []} />
      </div>

      <div className="tw-opacity-0 tw-animate-fadeIn tw-delay-[900]">
        <CuratedPicks title={promoPage.curatedProductsTitle} products={promoPage?.curatedProducts || []} />
      </div>

      <div className="tw-opacity-0 tw-animate-fadeIn tw-delay-[1200]">
        <PromoBox
          imgSrc={promoPage.calloutHero.imgSrcMobile!}
          imgSrcMobile={promoPage.calloutHero.imgSrcMobile}
          imgSrcTablet={promoPage.calloutHero.imgSrcDesktop}
          imgSrcDesktop={promoPage.calloutHero.imgSrcDesktop}
          heading={promoPage?.calloutHero?.heading}
          paragraph={promoPage?.calloutHero?.paragraph}
          linkHref={promoPage?.calloutHero?.linkHref}
          linkText={promoPage?.calloutHero?.linkText}
          disableGrid
          className="tw-min-h-[320px]"
          contentPosition={promoPage.calloutHero.contentPosition}
        />
      </div>
    </div>
  );
}